import { useDisplayedError } from './useDisplayedError'
import { useGetOrderReviewCollection } from './useGetOrderReviewCollection'
import { usePostOrderReviewCollection } from './usePostOrderReviewCollection'
import { useReviewCollectionForm } from './useReviewCollectionForm'

export function useReviewCollection() {
  const { data, error, getReviewCollectionPromise } =
    useGetOrderReviewCollection()

  const displayedError = useDisplayedError(error)

  const submit = usePostOrderReviewCollection()

  const {
    formStep,
    isSummaryStep,
    averageRate,
    updatedAverageRate,
    questions,
    validators,
    form,
    layout,
    goToPreviousStep,
    goToNextStep,
    goToFirstStep,
    isFirstStep,
    submitStep,
    submitPending,
    buildFormForCurrentStep,
  } = useReviewCollectionForm(data, submit)

  return {
    data,
    displayedError,
    getReviewCollectionPromise,
    submitPending,
    formStep,
    isSummaryStep,
    averageRate,
    updatedAverageRate,
    questions,
    validators,
    form,
    layout,
    goToPreviousStep,
    goToNextStep,
    goToFirstStep,
    isFirstStep,
    submitStep,
    buildFormForCurrentStep,
  }
}
